var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashTransparent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 23.7083C2.25 25.3125 3.4875 26.625 5 26.625L16 26.625C17.5125 26.625 18.75 25.3125 18.75 23.7083L18.75 6.20833L2.25 6.20833L2.25 23.7083ZM5 9.125L16 9.125L16 23.7083L5 23.7083L5 9.125ZM15.3125 1.83333L13.9375 0.375L7.0625 0.375L5.6875 1.83333L0.875 1.83333L0.875 4.75L20.125 4.75L20.125 1.83333L15.3125 1.83333Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashTransparent);
export default __webpack_public_path__ + "static/media/trashTransparent.33a766a753f7e028eab32c31965e3ca5.svg";
export { ForwardRef as ReactComponent };